import { useCallback } from "react";
import type { SimpleTableConfig, BaseEntity } from "../../types";
import { handleColumnResize, resetColumnWidths } from "../../utils";

interface UseColumnCallbacksProps<TData extends BaseEntity> {
  config: SimpleTableConfig<TData>;
  setColumnWidths: React.Dispatch<React.SetStateAction<Record<string, number>>>;
}

export function useColumnCallbacks<TData extends BaseEntity>({
  config,
  setColumnWidths,
}: UseColumnCallbacksProps<TData>) {
  const handleColumnResizeCallback = useCallback(
    (columnId: string, newWidth: number) => {
      handleColumnResize(columnId, newWidth, config.fields, setColumnWidths);
    },
    [config.fields, setColumnWidths]
  );

  const resetColumnWidthsCallback = useCallback(() => {
    resetColumnWidths(config.fields, setColumnWidths);
  }, [config.fields, setColumnWidths]);

  return {
    handleColumnResizeCallback,
    resetColumnWidthsCallback,
  };
}
